"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _ButtonGroup = _interopRequireDefault(require("@material-ui/core/ButtonGroup"));

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _FormLabel = _interopRequireDefault(require("@material-ui/core/FormLabel"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    width: "100%"
  },
  label: {},
  body: {
    marginTop: theme.spacing(1)
  },
  group: {
    margin: props => {
      return theme.spacing(props.spacing / 2 * -1);
    }
  },
  button: {
    flexBasis: 0,
    flexGrow: 1,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    fontWeight: "bold",
    height: theme.spacing(7),
    padding: theme.spacing(2),
    margin: props => {
      return theme.spacing(props.spacing / 2);
    },
    border: "2px solid",
    borderColor: theme.palette.grey[500],
    "&:hover": {
      borderColor: props => {
        return props.color;
      }
    },
    maxWidth: theme.spacing(20),
    width: "100%",
    "&[aria-selected=true]": {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      borderColor: theme.palette.primary.main,
      backgroundColor: props => {
        return props.color;
      },
      borderColor: props => {
        return props.color;
      }
    }
  }
}));
const colors = {
  "1": "#EB5757",
  "2": "#F2994A",
  "3": "#F2C94C"
};

const PriorityButton = ({
  selected,
  value,
  label,
  onClick
}) => {
  const color = value && colors[value];
  const classes = useStyles({
    color,
    spacing: 1
  });
  return _react.default.createElement(_ButtonBase.default, {
    className: classes.button,
    value: value,
    "aria-selected": selected,
    onClick: onClick
  }, label);
};

const PriorityWidget = ({
  label,
  helperText,
  value,
  options = [],
  onChange
}) => {
  const classes = useStyles({
    spacing: 1
  });
  return _react.default.createElement(_FormControl.default, {
    className: classes.root,
    component: "fieldset"
  }, _react.default.createElement(_FormLabel.default, {
    className: classes.label,
    component: "legend"
  }, label), _react.default.createElement("div", {
    className: classes.body
  }, _react.default.createElement(_ButtonGroup.default, {
    fullWidth: true,
    className: classes.group
  }, options.map((option, index) => {
    return _react.default.createElement(PriorityButton, _extends({}, option, {
      selected: value === option.value,
      key: index,
      onClick: () => onChange(option.value)
    }));
  }))), helperText && _react.default.createElement(_FormHelperText.default, null, helperText));
};

var _default = PriorityWidget;
exports.default = _default;
module.exports = exports.default;